/**
 * The merge dialog carries every value as a string, so a tag list travels
 * comma-joined — the same `', '` join `toText` shows in the read-only columns.
 * A tag that itself contains a comma splits in two on the way back.
 */
export function joinTags(tags: readonly string[]): string {
  return tags.join(', ');
}

export function splitTags(value: string): string[] {
  return value
    .split(',')
    .map(tag => tag.trim())
    .filter(Boolean);
}
